
import React, { Component } from "react";
import axios from "axios";
import styled from "styled-components";

import AS from "../../Login/Service/Authentication";
import CS from "../../../commons/services/Common";
import VS from "../../../commons/services/Validation";

import Date from "../../../commons/components/Date";
import DateCustom from "../../../commons/components/DateCustom";
import PageTitle from "../../../commons/components/PageTitle";

import {
  CreateForm,
  FormRow,
  FormSplit,
  FormThead,
  BtnGroup,
  Checkbox,
  SelectContainer,
} from "../PlantListStyle";
import InputErrorMsgWrapper from "../../../commons/components/input/InputErrorWrap";
import { STORAGE_SELECT_MESSAGE } from "./model/constants";
import { Message, MessageBox } from "element-react";
import { CONFIRM_TEXT } from "../../../commons/constants/confirm/CONFIRM_TEXT";
import { ROUTES } from "../../../commons/constants/routes/routes";
import { withTranslation } from "react-i18next";
import { ButtonWidthDeviceList, LabelWidth, LabelWidthClass, LabelWidthLinkedDeviceInput } from "./translationUiConts";

class PowerDeviceCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSaved: true,
      deviceTypeId: 1,
      projectId: null,
      deviceData: [],
      deviceTypeMapping: [],
      selectedDeviceId: null,
      showStorageOptions: false,
      showStorageTypes: false,
      validationErrors: {},
      heatpumpList: [],
      selectedHeatpumpId: "",
      deviceCompany: "",
      modelName: "",
      pwConsumption: "",
      siteNo: "",
    };

    this.moveNextStep = this.moveNextStep.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDeviceList = this.handleDeviceList.bind(this);
    this.handleStorageOptionsToggle =
      this.handleStorageOptionsToggle.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.closeSelectBox = this.closeSelectBox.bind(this);
  }

  componentDidMount() {
    const { state } = this.props.location;
    if (state) {
      this.setState({
        projectId: state.projectId,
        deviceData: state.deviceData,
        deviceTypeMapping: state.deviceTypeMapping,
      }, () => {
        this.fetchProjectSiteNo(state.projectId);
      });
    }
    this.fetchHeatpumpList();
  }

  async fetchProjectSiteNo(projectId) {
    try {
      const res = await axios.get(`/cst/api/project/id/${projectId}`);
      const siteNo = res.data?.siteNo || "";
      this.setState({ siteNo });
    } catch (e) {
      console.error("프로젝트 정보 조회 실패", e);
    }
  }
  componentDidUpdate(prev) {
    // select box가 열려있을 때 document click closeSelectBox event 추가
    if (this.state.showStorageOptions || this.state.showStorageTypes) {
      document.addEventListener("click", this.closeSelectBox);
    }
    // select box가 닫혔을 때 document click closeSelectBox event 제거 (메모리 누수 방지)
    if (!this.state.showStorageOptions && !this.state.showStorageTypes) {
      document.removeEventListener("click", this.closeSelectBox);
    }
  }

  closeSelectBox() {
    this.setState({
      showStorageOptions: false,
      showStorageTypes: false,
    });
  }

  async fetchHeatpumpList() {
    try {
      const res = await axios.get('/api/heatpump');
      this.setState({ heatpumpList: res.data || [] });
    } catch (e) {}
  }

  handleHeatpumpSelect = (e) => {
    const id = e.target.value;
    const hp = this.state.heatpumpList.find(h => String(h.id) === String(id));
    if (!hp) return;
    const validationErrors = { ...this.state.validationErrors };
    delete validationErrors.deviceCompany;
    delete validationErrors.modelName;
    delete validationErrors.pwConsumption;
    this.setState({
      selectedHeatpumpId: id,
      deviceCompany: hp.company,
      modelName: hp.model,
      pwConsumption: String(hp.size),
      validationErrors,
      isSaved: false,
    });
  };

  async handleSubmit(e) {
    e.preventDefault();
    const isSaved = await this.saveDevice();

    if (isSaved) {
      this.setState({ isSaved: true });
    }
  }

  // 해당 input의 validation error 삭제, 변경사항 유무 확인
  removeError(name) {
    const { validationErrors } = this.state;
    delete validationErrors[name];

    this.setState((prev) => ({ ...prev, validationErrors, isSaved: false }));
  }

  // validation error input으로 스크롤 이동
  scrollErrorInput() {
    const { validationErrors } = this.state;
    const keys = Object.keys(validationErrors);
    // validationErrors에 error가 등록 됐을 때
    if (keys.length > 0) {
      const errorMsgElem = document.querySelector(`.valid-error`); // InputErrorMsgWrapper의 최상단의 span class를 찾음
      errorMsgElem.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  handleStorageDeviceSelect = (deviceId, deviceName) => {
    this.setState({
      selectedDeviceId: deviceId,
      selectedStorageDeviceName: deviceName,
      showStorageOptions: false,
    });
  };

  handleStorageOptionsToggle = (e) => {
    const target = e.target.id;
    if (target === "defaultValue") {
      this.setState((prevState) => ({
        showStorageTypes: !prevState.showStorageTypes,
      }));
    } else if (target === "storageDefaultValue") {
      this.setState((prevState) => ({
        showStorageOptions: !prevState.showStorageOptions,
      }));
    }
  };

  async handleDeviceList(e) {
    const { t } = this.props;
    e.preventDefault();
    if (this.state.isSaved) {
      this.props.history.push(ROUTES.PLANT_LIST(this.state.projectId).MAIN + "?tab=1"); // tab: 0 = 발전소, 1 = 전력기기, 2 = 배터리
      return;
    }
    MessageBox.confirm(CONFIRM_TEXT.MOVE_TO_LIST, "Confirm", {
      confirmButtonText: t('key610'),
      cancelButtonText: t('key611'),
      type: "info",
    }).then(() => { 
      this.props.history.push(ROUTES.PLANT_LIST(this.state.projectId).MAIN + "?tab=1");
    }).catch(() => {
      Message({
        iconClass: "cancel",
        type: "info",
        message: t('key593'),
      })
      return;
    })
  }

  validateForm(data) {
    const { t } = this.props;
    const validationErrors = {};

    if (!this.state.deviceTypeId) {
      validationErrors.deviceTypeId = t('key594'); // 전력기기 종류를 선택하세요.
    }
    if (!data.get("name")) {
      validationErrors.name = t('key595'); // 전력기기명을 입력하세요.
    }
    if (!data.get("deviceCompany")) {
      validationErrors.deviceCompany = "제조사를 입력하세요.";
    }
    if (!data.get("modelName")) {
      validationErrors.modelName = t('key596'); // Model 명을 입력하세요.
    }
    if (!data.get("pwConsumption")) {
      validationErrors.pwConsumption = t('key597'); // 소비전력을 입력하세요.
    }
    if (!data.get("siteNo")) {
      validationErrors.siteNo = t('key598'); // Site 번호를 입력하세요.
    }
    if (!data.get("deviceNo")) {
      validationErrors.deviceNo = t('key599'); // 기기 번호를 입력하세요.
    }
    if (!data.get("rtuNo")) {
      validationErrors.rtuNo = t('key600'); // RTU 번호를 입력하세요.
    }
    if (!this.state.operationStartDt) {
      validationErrors.operationStartDt = t('key601'); // 운전 개시일을 입력하세요.
    }
    if (!this.state.serviceWarrantyDt) {
      validationErrors.serviceWarrantyDt = t('key602'); // 서비스 보증 기간을 입력하세요.
    }
    if (data.get("drContr") && !data.get("drResIdx")) {
      validationErrors.drResIdx = t('key603'); //+DR(수요반응) 체크시 DR자원 식별자는 필수값입니다. DR자원 식별자를 입력하세요.
    }
    if (this.state.deviceTypeId === 6 && !data.get("externalUrl")) { // 연계 전력기기 선택 시 연계 URL 필수
      validationErrors.externalUrl = "연계 URL을 입력하세요.";
    }

    this.setState({ validationErrors }, this.scrollErrorInput);

    return Object.keys(validationErrors).length === 0;
  }

  async saveDevice() {
    const data = new FormData(document.querySelector("form"));
    if (!this.validateForm(data)) return;

    this.item = {
      constructorId: AS.getLoggedInId(),
      typeId: this.state.deviceTypeId,
      name: data.get("name"),
      projectId: this.state.projectId,
      deviceCompany: data.get("deviceCompany"),
      modelName: data.get("modelName"),
      pwConsumption: data.get("pwConsumption"),
      siteNo: data.get("siteNo"),
      rtuNo: data.get("rtuNo"),
      rtuSerialNo: data.get("rtuSerialNo") || null,
      deviceNo: data.get("deviceNo"),
      pwContr: this.state.deviceTypeId !== 6 ? data.get("pwContr") ? 1 : 0 : 0,
      tempContr: this.state.deviceTypeId !== 6 ? data.get("tempContr") ? 1 : 0 : 0,
      rsdContr: this.state.deviceTypeId !== 6 ? data.get("rsdContr") ? 1 : 0 : 0,
      pwModeContr: this.state.deviceTypeId !== 6 ? data.get("pwModeContr") ? 1 : 0 : 0,
      timeContr: this.state.deviceTypeId !== 6 ? data.get("timeContr") ? 1 : 0 : 0,
      drContr: this.state.deviceTypeId !== 6 ? data.get("drContr") ? 1 : 0 : 0,
      drResIdx: this.state.deviceTypeId !== 6 ? data.get("drResIdx") : null,
      parentId: this.state.selectedDeviceId || null,
      serviceStartDt: this.state.operationStartDt,
      serviceWarrantyDt: this.state.serviceWarrantyDt,
      externalUrl: this.state.deviceTypeId === 6 ? data.get("externalUrl") || null : null,
    };

    // console.log(this.item);
    try {
      let result = await CS.create("/cst/api/device", this.item);
      return result.isSuccess;
    } catch (error) {
      return false;
    }
  }

  moveNextStep(plantId) {
    if (plantId === "") {
      CS.notification("warning", "임시저장 후 모듈배치 화면으로 이동하세요.");
      return;
    }
    // this.props.history.push(`/plant-list/drawing/${plantId}`);
    this.props.history.push(ROUTES.PLANT_LIST(this.state.projectId).DRAWING(plantId));
  }

  handleDateChange(name, dt) {
    this.setState({
      [name]: dt,
    });
  }

  optionsOnClick = (e, id) => {
    let default_val = document.getElementById("defaultValue");

    const selectedOption = this.state.deviceTypeMapping.find(
      (item) => item.id === id
    )?.type;
    default_val.innerText = selectedOption;

    this.setState({
      deviceTypeId: id,
      selectedDeviceId: null, // 전력기기 종류 변경 시 축열조 선택 초기화
      showStorageTypes: false,
    });
    this.removeError("deviceTypeId");
  };

  boilerOptionsOnClick = (e, id, name) => {
    let default_val = document.getElementById("storageDefaultValue");
    default_val.innerText = name;
    this.setState({
      selectedDeviceId: id,
      selectedStorageDeviceName: name,
      showStorageOptions: false,
    });

    this.removeError("selectedDeviceId");
  };

  handleBoilerSelect = (deviceId) => {
    this.setState({
      selectedDeviceId: deviceId,
      showStorageOptions: false, // 선택 후 드롭다운 닫기
    });
  };

  render() {
    const { t, i18n } = this.props;
    const { validationErrors } = this.state;
    const isBoilerSelected =
      this.state.deviceTypeMapping.find(
        (item) => item.id === this.state.deviceTypeId
      )?.id === 1
    const isExternalSelected =
      this.state.deviceTypeMapping.find(
        (item) => item.id === this.state.deviceTypeId
      )?.id === 6

    const selectOptionDevices = this.state.deviceData
      .filter((device) => {
        // 축열조만 필터링
        // const deviceMapping = this.state.deviceTypeMapping.find(
        //   (mapping) => (mapping.type === "축열조" && mapping.id === device.typeId)
        // );
        // siteNo, rtuNo가 같은 경우만 노출
        const data = new FormData(document.querySelector("form"));
        const siteNo = data.get("siteNo");
        const rtuNo = data.get("rtuNo");
        // 사이트번호, 기기번호, RTU 번호가 일치하는 전력기기만 필터링
        if (device.siteNo !== siteNo || device.rtuNo !== rtuNo) return false;
        return true;
      })
      // .map((device) => ({ // 축열조 1개 이상 등록된 경우 선택 비활성화
      //   ...device,
      //   isDisabled:
      //     this.state.deviceData.reduce((count, dataDevice) => {
      //       if (device.typeId === 1) return count; 
      //       return dataDevice.parentId === device.id ? count + 1 : count;
      //     }, 0) >= 1, // 해당 축열조에 보일러가 1개 이상 등록되어 있으면 선택 비활성화
      // }));
    return (
      <>
        <PageTitle title={t('key47')} location={t('key604')} />
        <CreateForm onSubmit={this.handleSubmit}>
          <FormSplit>
            <FormRow>
              <FormThead width={LabelWidth(i18n)} required={true}>{t('key269')}</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors.deviceTypeId}
                message={validationErrors.deviceTypeId}
              >
                <SelectContainer>
                  <div
                    className="select"
                    onClick={(e) => this.handleStorageOptionsToggle(e)}
                  >
                    <p id="defaultValue">
                      {this.state.deviceTypeMapping.find(
                        (item) => item.id === this.state.deviceTypeId
                      )?.type || t('key605')}
                    </p>
                  </div>
                  {this.state.showStorageTypes && (
                    <div className="option-container">
                      {this.state.deviceTypeMapping.map((device) => (
                        <div
                          className="option"
                          onClick={(e) => this.optionsOnClick(e, device.id)}
                          key={device.id}
                        >
                          <label htmlFor={device.type}>{device.type}</label>
                        </div>
                      ))}
                    </div>
                  )}
                </SelectContainer>
              </InputErrorMsgWrapper>
            </FormRow>
            <FormRow>
              <FormThead width={LabelWidth(i18n)}  required={true}>{t('key271')}</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors.name}
                message={validationErrors.name}
              >
                <input
                  type="text"
                  className="w436 radius4"
                  placeholder={t('key606')}
                  onChange={(event) => {
                    this.removeError("name");
                    VS.characterCheck(event);
                  }}
                  name="name"
                />
              </InputErrorMsgWrapper>
            </FormRow>
            <FormRow>
              <FormThead width={LabelWidth(i18n)} required={true}>제조사</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors.deviceCompany}
                message={validationErrors.deviceCompany}
              >
                <input
                  type="text"
                  className="w436 radius4"
                  placeholder="제조사를 입력하세요"
                  value={this.state.deviceCompany}
                  onChange={(event) => {
                    VS.characterCheck(event);
                    this.setState({ deviceCompany: event.target.value });
                    this.removeError("deviceCompany");
                  }}
                  name="deviceCompany"
                />
              </InputErrorMsgWrapper>
              <select
                style={{
                  display: 'inline-block',
                  verticalAlign: 'middle',
                  marginLeft: '12px',
                  padding: '10px 12px',
                  border: '1px solid #d5d8de',
                  borderRadius: '4px',
                  fontSize: '15px',
                  color: '#262626',
                  backgroundColor: 'white',
                  cursor: 'pointer',
                  width: '200px',
                  height: '42px',
                }}
                value={this.state.selectedHeatpumpId}
                onChange={this.handleHeatpumpSelect}
              >
                <option value="">모델 선택</option>
                {this.state.heatpumpList.map(hp => (
                  <option key={hp.id} value={hp.id}>{hp.model}({hp.company})</option>
                ))}
              </select>
            </FormRow>
            <FormRow>
              <FormThead width={LabelWidth(i18n)}  required={true}>{t('key272')}</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors.modelName}
                message={validationErrors.modelName}
              >
                <input
                  type="text"
                  className="w436 radius4"
                  placeholder={t('key272')}
                  value={this.state.modelName}
                  onChange={(event) => {
                    VS.characterCheck(event);
                    this.setState({ modelName: event.target.value });
                    this.removeError("modelName");
                  }}
                  name="modelName"
                />
              </InputErrorMsgWrapper>
            </FormRow>
            <FormRow>
              <FormThead width={LabelWidth(i18n)} required={true}>{t('key273')}</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors.pwConsumption}
                message={validationErrors.pwConsumption}
              >
                <input
                  type="text"
                  className="w436 radius4"
                  placeholder={t('key273')}
                  value={this.state.pwConsumption}
                  name="pwConsumption"
                  onChange={(event) => {
                    VS.onInput("number", event);
                    this.setState({ pwConsumption: event.target.value });
                    this.removeError("pwConsumption");
                  }}
                />
              </InputErrorMsgWrapper>
            </FormRow>
            <FormRow>
              <FormThead width={LabelWidth(i18n)} required={true}>{t('key274')}</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors.siteNo}
                message={validationErrors.siteNo}
              >
                <input
                  type="text"
                  className="w436 radius4"
                  placeholder={t('key274')}
                  name="siteNo"
                  value={this.state.siteNo}
                  readOnly
                  style={{ backgroundColor: "#f5f5f5", color: "#888" }}
                />
              </InputErrorMsgWrapper>
            </FormRow>
            <FormRow>
              <FormThead width={LabelWidth(i18n)} required={true}>{t('key275')}</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors.deviceNo}
                message={validationErrors.deviceNo}
              >
                <input
                  type="text"
                  className="w436 radius4"
                  placeholder={t('key275')}
                  name="deviceNo"
                  onChange={(event) => {
                    VS.onInput("number", event);
                    // VS.onInput("eng&Number&Hyphen", event);
                    this.removeError("deviceNo");
                  }}
                />
              </InputErrorMsgWrapper>
              <span style={{ display: 'inline-block', verticalAlign: 'middle', marginLeft: '12px', fontSize: '13px', color: '#8c8c8c' }}>
                기본값 1로 입력, 현장에 여러 대를 사용할 경우 +1씩 증가해 주세요
              </span>
            </FormRow>
            <FormRow>
              <FormThead width={LabelWidth(i18n)} required={true}>{t('key277')}</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors.rtuNo}
                message={validationErrors.rtuNo}
              >
                <input
                  type="text"
                  className="w436 radius4"
                  placeholder={t('key277')}
                  name="rtuNo"
                  onChange={(event) => {
                    VS.onInput("number", event);
                    // VS.onInput("eng&Number&Hyphen", event);
                    this.removeError("rtuNo");
                  }}
                />
              </InputErrorMsgWrapper>
              <span style={{ display: 'inline-block', verticalAlign: 'middle', marginLeft: '12px', fontSize: '13px', color: '#8c8c8c' }}>
                기본값 1로 입력, 현장에 여러 대를 사용할 경우 +1씩 증가해 주세요
              </span>
            </FormRow>
            <FormRow>
              <FormThead width={LabelWidth(i18n)} required={false}>RTU 시리얼번호</FormThead>
              <input
                type="text"
                className="w436 radius4"
                placeholder="RTU 시리얼번호"
                name="rtuSerialNo"
                onChange={() => this.setState({ isSaved: false })}
              />
              <span style={{ display: 'inline-block', verticalAlign: 'middle', marginLeft: '12px', fontSize: '13px', color: '#8c8c8c' }}>
                직접입력 또는 현장담당자가 원격 입력 가능
              </span>
            </FormRow>
            {
              !isExternalSelected && (
                <FormRow>
                  <FormThead width={LabelWidth(i18n)} required={false}>{t('key278')}</FormThead>
                    <InputErrorMsgWrapper
                      isError={validationErrors.drResIdx}
                      message={validationErrors.drResIdx}
                    >
                      <input
                        type="text"
                        className="w436 radius4"
                        placeholder={t('key278')}
                        name="drResIdx"
                        onChange={(event) => {
                          VS.onInput("number", event);
                          this.removeError("drResIdx");
                          this.setState({ isSaved: false });
                        }}
                      />
                    </InputErrorMsgWrapper>
                </FormRow>
              )
            }
            <FormRow>
              <FormThead width={LabelWidth(i18n)} required={true}>{t('key279')}</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors.operationStartDt}
                message={validationErrors.operationStartDt}
              >
                <Date
                  name="operationStartDt"
                  handleDateChange={(name, dt) => {
                    this.removeError("operationStartDt");
                    this.handleDateChange(name, dt);
                  }}
                />
              </InputErrorMsgWrapper>
              <FormThead width={LabelWidth(i18n)} className="ml-25" required={true}>{t('key281')}</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors.serviceWarrantyDt}
                message={validationErrors.serviceWarrantyDt}
              >
                <DateCustom
                  name="serviceWarrantyDt"
                  handleDateChange={(name, dt) => {
                    this.removeError("serviceWarrantyDt");
                    this.handleDateChange(name, dt);
                  }}
                />
              </InputErrorMsgWrapper>
            </FormRow>
            {
              !isExternalSelected && (

                <FormRow>
                  <FormThead width={LabelWidthLinkedDeviceInput(i18n)} >{t('key283')}</FormThead>
                  {/* <InputErrorMsgWrapper
                    isError={true}
                    message="제어 항목을 선택하세요."
                  > */}
                  <Checkbox>
                    <input type="checkbox" name="pwContr" id="power" onChange={() => this.setState({ isSaved: false })}/>
                    <label htmlFor="power"></label>
                    <span>{t('key284')}</span>
                  </Checkbox>
                  <Checkbox>
                    <input type="checkbox" name="tempContr" id="temperature" onChange={() => this.setState({ isSaved: false })}/>
                    <label htmlFor="temperature"></label>
                    <span>{t('key285')}</span>
                  </Checkbox>
                  <Checkbox>
                    <input type="checkbox" name="rsdContr" id="block" onChange={() => this.setState({ isSaved: false })}/>
                    <label htmlFor="block"></label>
                    <span>{t('key286')}</span>
                  </Checkbox>
                  <Checkbox>
                    <input type="checkbox" name="pwModeContr" id="action" onChange={() => this.setState({ isSaved: false })}/>
                    <label htmlFor="action"></label>
                    <span>{t('key287')}</span>
                  </Checkbox>
                  <Checkbox>
                    <input type="checkbox" name="timeContr" id="reservation" onChange={() => this.setState({ isSaved: false })}/>
                    <label htmlFor="reservation"></label>
                    <span>{t('key288')}</span>
                  </Checkbox>
                  <Checkbox>
                    <input type="checkbox" name="drContr" id="drContr" onChange={() => this.setState({ isSaved: false })}/>
                    <label htmlFor="drContr"></label>
                    <span>{t('key289')}</span>
                  </Checkbox>
                  {/* </InputErrorMsgWrapper> */}
                </FormRow>
              )
            }
            {
              isExternalSelected && (
                <FormRow>
                  <FormThead width={LabelWidth(i18n)} required={true}>
                    연계 URL
                  </FormThead>
                  <InputErrorMsgWrapper
                    isError={validationErrors.externalUrl}
                    message={validationErrors.externalUrl}
                  >
                    <input
                      type="text"
                      className="w436 radius4"
                      placeholder="연계 URL을 입력하세요."
                      onChange={(event) => {
                        this.removeError("externalUrl");
                      }}
                      name="externalUrl"
                    />
                  </InputErrorMsgWrapper>
                </FormRow>
              )
            }
            {isBoilerSelected && (
              <FormRow>
                <FormThead width={LabelWidth(i18n)} required={false}>{t('key290')}</FormThead>
                <InputErrorMsgWrapper
                  isError={validationErrors.selectedDeviceId}
                  message={validationErrors.selectedDeviceId}
                >
                  <SelectContainer>
                    <div
                      className="select"
                      onClick={(e) => this.handleStorageOptionsToggle(e)}
                    >
                      <p id="storageDefaultValue">
                        {this.state.selectedStorageDeviceName ||
                          (selectOptionDevices.length > 0
                            ? STORAGE_SELECT_MESSAGE(t).DEFAULT
                            : STORAGE_SELECT_MESSAGE(t).NO_STORAGE)}
                      </p>
                      {this.state.showStorageOptions && (
                        <div className="option-container">
                          {selectOptionDevices.length > 0 ? (
                            selectOptionDevices.map((device) => (
                              <div
                                key={device.id}
                                onClick={
                                  !device.isDisabled
                                    ? (e) =>
                                        this.boilerOptionsOnClick(
                                          e,
                                          device.id,
                                          device.name
                                        )
                                    : null
                                }
                                className={`option ${
                                  device.isDisabled ? "disabled" : ""
                                }`}
                              >
                                <label>{device.name}</label>
                              </div>
                            ))
                          ) : (
                            <p className="option">
                              <label>{STORAGE_SELECT_MESSAGE(t).NO_STORAGE}</label>
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  </SelectContainer>
                </InputErrorMsgWrapper>
                <span className="option pl-10"
                  style={{
                    letterSpacing: "-0.02em",
                  }}
                >
                  {t('key293')}
                </span>
              </FormRow>
            )}
          </FormSplit>
          <BtnGroup>
            <button type="button" onClick={this.handleDeviceList} >
              {t('key295')}
            </button>
            <button type="submit">{t('key296')}</button>
          </BtnGroup>
        </CreateForm>
      </>
    );
  }
}

export default withTranslation()(PowerDeviceCreate);

